import { jwtDecode } from "jwt-decode";
import { authEndPoints } from "../constants/apiEndPoints";
import ApiUtil from "../utils/ApiUtils";
import { removeCookie, setCookie } from "../utils/GeneralUtils";
import { setIsLoggedIn } from "../redux/slices/auth";
import store from "../redux/store";

const getAccessToken = () => {
  const accessToken = JSON.parse(localStorage.getItem("accessToken") || "null");
  if (accessToken) {
    return accessToken;
  }
  return null;
};

const getRefreshToken = () => {
  const refreshToken = JSON.parse(
    localStorage.getItem("refreshToken") || "null"
  );
  if (refreshToken) {
    return refreshToken;
  }
  return null;
};

const storeAccessToken = (token) => {
  return new Promise(async (resolve, reject) => {
    try {
      await removeAccessToken();
      const newAccessToken = token?.access_token;
      const newRefreshToken = token?.refresh_token;

      await setCookie("accessToken", JSON.stringify(newAccessToken));
      await setCookie("refreshToken", JSON.stringify(newRefreshToken));

      setTimeout(() => {
        resolve(true);
      }, 1000);
    } catch (error) {
      reject(error);
    }
  });
};
const refreshTokenUpdate = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await ApiUtil.getWithoutToken(
        authEndPoints.refreshToken,
        body
      );

      if (response.refresh_token && response.access_token) {
        store.dispatch(setIsLoggedIn(true));

        localStorage.setItem(
          "accessToken",
          JSON.stringify(response.access_token)
        );

        localStorage.setItem(
          "refreshToken",
          JSON.stringify(response.refresh_token)
        );
      }
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};
const loginCheck = () => {
  // const credentials: any = getCookie("accessToken");
  // if (credentials) {
  //   const { exp }: { exp: number } = jwtDecode(JSON.parse(credentials));
  //   if (Date.now() <= exp * 1000) {
  //     return true;
  //   } else {
  //     removeCookie("accessToken");
  //     removeCookie("refreshToken");
  //     return false;
  //   }
  // }
  // return false;

  const accessToken = JSON.parse(localStorage.getItem("accessToken") || "null");

  if (accessToken) {
    const { exp } = jwtDecode(accessToken);
    if (Date.now() <= exp * 1000) {
      return true;
    }
  }
  return false;
};

const removeAccessToken = async () => {
  await new Promise((resolve, reject) => {
    try {
      localStorage.clear();
      removeCookie("accessToken");
      removeCookie("refreshToken");
      resolve(true);
    } catch (error) {
      reject(error);
    }
  });
};

async function login(userName, password) {
  try {
    // const res = (await ApiUtil.postWithoutToken(authEndPoints.login, {
    //   userName: userName,
    //   password,
    // })) as any;
    // if (res.data) {
    //   const { access_token, refresh_token } = res.data;
    // await storeAccessToken({ access_token, refresh_token } as Credentials);
    // }
    await ApiUtil.postWithoutToken(authEndPoints.login, {
      userName: userName,
      password,
    }).then((res) => {
      return res;
    });
  } catch (error) {
    throw error;
  }
}

const logout = () => {
  removeCookie("refreshToken");
  removeCookie("accessToken");
  localStorage.clear();
  window.location.reload();
};

const logoutTokenError = () => {
  void removeAccessToken();
  localStorage.clear();
  window.history.replaceState(null, "", authEndPoints.logout);
  window.location.reload();
};

const getAuthUserDetails = () => {
  const user = JSON.parse(localStorage.getItem("userDetails"));
  return user ? user : {};
};

const logoutUser = async () => {
  // dispatch(setIsLoggedIn(loginCheck()));
};
export {
  getAccessToken,
  getRefreshToken,
  storeAccessToken,
  removeAccessToken,
  login,
  logout,
  logoutTokenError,
  loginCheck,
  refreshTokenUpdate,
  getAuthUserDetails,
  logoutUser,
};
